import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Stack } from '../../component-stack';
import { Children, forwardRef } from 'react';
/**
 * A component to show a horizontal list of social media icons.
 */
export const SocialMediaIcons = forwardRef(({ icons, ...props }, ref) => (_jsx(Stack, { direction: "horizontal", align: "center", spacing: "small-lg", ...props, ref: ref, children: Children.map(icons.map((icon) => icon({})), (icon) => icon) })));
SocialMediaIcons.displayName = 'SocialMediaIcons';
